import { Dispatch, SetStateAction } from 'react';

import { ISanityImage } from '@rbi-ctg/menu';
import { IMenuSelectionInput } from 'generated/graphql-gateway';

export enum MinimalCartEntryType {
  item = 'item',
  combo = 'combo',
  modifier = 'modifier',
  incentive = 'incentive',
  discount = 'discount',
  reward = 'reward',
  donation = 'donation',
  extra = 'extra',
}

// source of truth for the minimal cart entry
export type IMinimalCartEntry = Omit<IMenuSelectionInput, 'externalReferencesId' | 'referenceId'>;

// this is the cart entry that is used in the cart
export interface ICartEntry extends IMinimalCartEntry {
  cartId?: string;
  isEdit?: boolean;
  name: string;
  image: ISanityImage;
  url: string;
  type: MinimalCartEntryType;
  children: ICartEntry[];

  // TODO: we may be able to leverage loyalty with some cart specific utilities
  rewardIdReference?: string;

  /** @deprecated the structure of the minimal cart define the type of item */
  rewardBenefitId?: string;

  /** @deprecated the structure of the minimal cart define the type of item */
  rewardId?: string;

  /** @deprecated we can use MinimalCartEntryType instead */
  isExtra?: boolean;

  /** @deprecated we can use MinimalCartEntryType instead */
  isDonation?: boolean;
}

export type CartState = {
  debug: boolean;
};

export type CartContext = CartState & {
  setCartState: Dispatch<SetStateAction<CartState>>;
};
